import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CreditCard } from '../../../credit-card/models/model';
import { cardFullDescription } from '../../../credit-card/utils/card-description';
import { Liability } from '../../models/liability.model';
import { DEFAULT_PATTERN } from '../../../shared/configs/date-config';

@Component({
standalone: false,
  selector: 'app-single-automatic-payment-created-dialog',
  styleUrls: ['./single-automatic-payment-created-dialog.component.scss'],
  templateUrl: './single-automatic-payment-created-dialog.component.html',
})
export class SingleAutomaticPaymentCreatedDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { liability: Liability; card: CreditCard }) {}

  public getFullDescription = cardFullDescription;
  public defaultPattern: string = DEFAULT_PATTERN;
}
